
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { adminSidebaseStyles, colors } from '../../../theme/style';
import { logout,navigateTo ,setSelectedClinic,setPatientsList,getAllPatients, getUsers, getAdmins, setUsersClinic, setAdmins, setSelectedButton } from '../../../redux/actions';
import { getRolesFromToken, getUserFromToken, isAdminClinic, isLoggedInis, isUserClinic } from '../../../utils/CFuncs';
import { roleTypes, roles, urls } from '../../../utils/Objects';
import { Items, Storage } from '../../../utils/StorageHelper';


class AdminSidebar extends Component {
  constructor(props) {
    super(props);

    this.handleLogout = this.handleLogout.bind(this);
    this.showUsers = this.showUsers.bind(this);
    this.showPaitents = this.showPaitents.bind(this);
    this.showClinicDetails = this.showClinicDetails.bind(this);
  
    this.showPaitentDetails = this.showPaitentDetails.bind(this);
    this.showClinics = this.showClinics.bind(this);
    this.showUserDetails = this.showUserDetails.bind(this);
    this.showAdmins= this.showAdmins.bind(this);
  }
  componentDidMount(){
    // const roles = getRolesFromToken()
    console.log("componentDidMount => ",this.props.clinic?.selectedClinic)
    console.log("AdminSidebar" + getUserFromToken().roleType)
    console.log(getUserFromToken())
 

  }
componentDidUpdate(){

console.log(this.props.nav)
  
}
  handleLogout() {
    this.props.logout();
  }


  showUserDetails() {
    this.props.setSelectedButton(urls.userDetails )
    this.props.navigateTo(urls.userDetails,{clinic:this.props.selectedClinic,userId:null})
  }
  
  
  
  showClinics() {
    this.props.setSelectedButton(urls.clinics )
    if(isLoggedInis(roles.Administrator)){
      Storage.remove(Items.clinicId)
    }
    this.props.navigateTo(urls.clinics);
  }

  showPaitents() {
    this.props.setSelectedButton(urls.patients )
    if(isLoggedInis(roles.Administrator)){
      Storage.remove(Items.clinicId)
      this.props.navigateTo(urls.patients);
    }else if(isLoggedInis(roles.HealthCareProvider)){
      this.props.navigateTo(urls.clinicPatients);
    }
    
  }
  showUsers() {
    if(isLoggedInis(roles.Administrator)){
      Storage.remove(Items.clinicId)
      this.props.setSelectedButton(urls.users )
      this.props.navigateTo(urls.users);
    }else if(isLoggedInis(roles.HealthCareProvider)){
      this.props.setSelectedButton(urls.clinicUsers )
      this.props.navigateTo(urls.clinicUsers);
    }

  }

  getPath(){
    if(isLoggedInis(roles.Administrator)){
      return urls.users
    }else if(isLoggedInis(roles.HealthCareProvider)){
      return urls.clinicUsers
    }
  }
  showAdmins(){
    if(isLoggedInis(roles.Administrator)){
      Storage.remove(Items.clinicId)
    }
    this.props.setUsersClinic([])
    this.props.setSelectedButton(urls.admins )
    this.props.navigateTo(urls.admins);

  }



  showClinicDetails() {
    this.props.setSelectedButton(urls.clinicDetails )
    this.props.navigateTo(urls.clinicDetails,{clinicId:null});
    
  }
  isClinicsPage(){
    const pagePath = this.props.location.pathname
    return pagePath.includes("admin-clinic")
  }
  
  showPaitentDetails(){
    this.props.setSelectedButton(urls.patientDetails )
    this.props.navigateTo(urls.patientDetails);
  }
  
  canShowUsers(){
    console.log('canShowUsers')
    const hasselectedClinic =this.props.selectedClinic !== null && this.props.selectedClinic !== undefined
    console.log(isLoggedInis(roles.Administrator) , isAdminClinic(), hasselectedClinic)
    return ( isLoggedInis(roles.Administrator)  || isAdminClinic() )&& hasselectedClinic
  }

  getStyle(path) {
    if(path === this.props.selectedButton){
      return {...adminSidebaseStyles.hoverLink,textDecoration: 'underline'  }
    }
    return adminSidebaseStyles.hoverLink

    
  }

  render() {
    const sidebarStyle = Object.assign({}, adminSidebaseStyles.sidebar, this.props.sidebarStyle);
    console.log(this.props.history)
    return(
      <section style={sidebarStyle}>
      <img src="/img/logoGreensunmedLogo.png" alt="Greensun Med Logo" style={adminSidebaseStyles.logo} />
        <section style={adminSidebaseStyles.links}>
        {(isLoggedInis(roles.Administrator) || isLoggedInis(roles.HealthCareProvider)) && (
          <>
            <div style={adminSidebaseStyles.alignLinks} onClick={() =>this.showPaitents()}>
              <img src="/img/patient_icon.png" alt="patients icon" style={adminSidebaseStyles.icon} />
            <div style={this.getStyle(urls.patients)}>Patients</div>
            </div>
            
           {!isUserClinic() &&   <div  style={adminSidebaseStyles.alignLinks} onClick={this.showUsers}>
              <img src="/img/recordSearch@2x.png" alt="clipboard icon" style={adminSidebaseStyles.icon} />
              <div style={this.getStyle(this.getPath())}>Users</div>
              </div>
            }
          </>
            )
          } 
        {isLoggedInis(roles.Administrator)  && (
          <>
          <div style={adminSidebaseStyles.alignLinks} onClick={this.showAdmins}>
            <img src="/img/employees_2@2x.png" alt="admin icon" style={adminSidebaseStyles.icon} />
            <div style={this.getStyle(urls.admins)}>Manage Admins</div>
          </div>
          <div style={adminSidebaseStyles.alignLinks} onClick={this.showClinics}>
              <img src="/img/baseline_apartment_black_24dp.png" alt="patients icon" style={adminSidebaseStyles.icon} />
            <div style={this.getStyle(urls.clinics)}>Clinics</div>
            </div>

     
          </>
      )}

        {isLoggedInis(roles.Patient)  && (

        <div style={adminSidebaseStyles.alignLinks} onClick={this.showPaitentDetails}>
            {/* <img src="/img/eyeList@2x.png" alt="patients icon" style={adminSidebaseStyles.icon} /> */}
            <img src="/img/my_details_img.png" alt="patients icon" style={adminSidebaseStyles.icon} />
           <div style={this.getStyle(urls.patientDetails)}>My Details</div>
          </div>
            )}
  
        {isLoggedInis(roles.HealthCareProvider)  && !isLoggedInis(roles.Administrator) && ( //for the user

          <div style={adminSidebaseStyles.alignLinks} onClick={this.showUserDetails}>
            <img src="/img/eyeList@2x.png" alt="patients icon" style={adminSidebaseStyles.icon} />
           <div style={this.getStyle(urls.userDetails)}>My Details</div>
          </div>
        )}

     {this.isClinicsPage() && isLoggedInis(roles.Administrator)  || isLoggedInis(roles.HealthCareProvider) && (
        <>
     

          <div style={adminSidebaseStyles.alignLinks} onClick={this.showClinicDetails}>
            <img src="/img/recordSearch@2x.png" alt="clipboard icon" style={adminSidebaseStyles.icon} />
            <div style={this.getStyle(urls.clinicDetails)}>Clinic Details</div>
        </div> 


        </>
            )}



        </section>
        <section className="sidebarBottomLinks" style={adminSidebaseStyles.links2}>
          <div style={adminSidebaseStyles.alignLinks}>
            {/* <img src="/img/support@2x.png" alt="clipboard icon" style={adminSidebaseStyles.icon} /> */}
            <img src="/img/need_help_img.png" alt="clipboard icon" style={adminSidebaseStyles.icon} />
            <div> Need Help?</div>
          </div>
          <div style={adminSidebaseStyles.alignLinks} onClick={this.handleLogout}>
            {/* <img src="/img/logOut@2x.png" alt="admin icon" style={adminSidebaseStyles.linkIcon} /> */}
            <img src="/img/logout_img.png" alt="admin icon" style={adminSidebaseStyles.linkIcon} />
            <div style={adminSidebaseStyles.hoverLink}>Log Out</div>
          </div>
        </section>
      </section>
    );
  }
}

AdminSidebar.defaultProps = {
  sidebarStyle: {},
}

AdminSidebar.propTypes = {
  sidebarStyle: PropTypes.object,
}

function mapStateToProps(state, ownProps) {
const selectedClinic = state.clinic.selectedClinic 
// const selectedClinic = state.clinic.selectedClinic || ownProps?.location?.state?.clinic
  const { user } = state;
  return {
    user,
    selectedClinic,
    history:state.nav.history,
    selectedButton:state.nav.selectedButton,
    nav:state.nav
  };
}

const mapDispatchToProps = {
  logout,
  setSelectedClinic,
  navigateTo,
  setPatientsList,
  getAdmins ,
  getUsers,
  getAllPatients,
  setAdmins,
  setUsersClinic,
  setSelectedButton

}


export default connect(mapStateToProps,mapDispatchToProps)(AdminSidebar);

